// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
// import Swal from 'sweetalert2';
// import "../Components/Register.css";
// import axios from 'axios';

// src/Register.js
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import Swal from 'sweetalert2';
import "../Components/Register.css";
import axios from 'axios';

import {
    MDBBtn,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBInput,
    MDBCheckbox,
    MDBRadio,
} from 'mdb-react-ui-kit';
import { BASE_URL } from '../config';

function Register() {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        password: '',
        cnic: '',
        contactNo: '',
        dob: '',
        city: '',
        country: '',
        currentAddress: '',
        permanentAddress: '',
        licenseNo: '',
        medicalInstitute: '',
        experience: '',
        currentWorking: '',
        doctorDutyTime: '',
        charges: '',
        authority: '',
        institutecountry: '',
        terms: false,
        specialization: '',
        image: null,
        resume: null,
        medicalDegree: null,
        gender: '',
        institutename: '',
        SpecialtyId: '',
        consultationFee: '',
    });

    const [specialists, setSpecialists] = useState([]);
    const [filteredSpecialists, setFilteredSpecialists] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchSpecialists = async () => {
            try {
                const response = await axios.get(`${BASE_URL}Specialist_List`, {
                    headers: {
                        accept: 'text/plain'
                    }
                });
                setSpecialists(response.data.getSpecialistDetail);
                setFilteredSpecialists(response.data.getSpecialistDetail);
            } catch (error) {
                console.error('Error fetching specialists:', error);
            }
        };

        fetchSpecialists();
    }, []);

    useEffect(() => {
        const results = specialists.filter(specialist =>
            specialist.specialization_Name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredSpecialists(results);
    }, [searchTerm, specialists]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));

        if (name === 'gender') {
            setFormData(prevData => ({
                ...prevData,
                gender: value
            }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setFormData(prevData => ({
                ...prevData,
                [name]: files[0]
            }));
        }
    };

    const handleSpecialtyChange = (specialty) => {
        setFormData(prevData => ({
            ...prevData,
            specialization: specialty.specialization_Name,
            SpecialtyId: specialty.id // Use the correct ID from the selected specialty
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validation check for SpecialtyId
        if (!formData.SpecialtyId) {
            Swal.fire({
                title: 'Error!',
                text: 'Please select a specialty.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Validation check for resume and medical degree
        if (!formData.resume) {
            Swal.fire({
                title: 'Error!',
                text: 'Please upload your resume.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (!formData.medicalDegree) {
            Swal.fire({
                title: 'Error!',
                text: 'Please upload your medical degree.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        const formDataObj = new FormData();
        formDataObj.append('Email', formData.email);
        formDataObj.append('Password', formData.password);
        formDataObj.append('MobileNumber', formData.contactNo); // Updated from MobileNumber to contactNo
        formDataObj.append('CNIC', formData.cnic);
        formDataObj.append('Name', formData.fullName);
        formDataObj.append('DoctorDutyTime', formData.doctorDutyTime);
        formDataObj.append('Gender', formData.gender);
        formDataObj.append('DateOfBirth', formData.dob);
        formDataObj.append('Address', formData.currentAddress);
        formDataObj.append('City', formData.city);
        formDataObj.append('SpecialtyId', formData.SpecialtyId);
        formDataObj.append('Country', formData.country);
        formDataObj.append('Specialization', formData.specialization || 'no');
        formDataObj.append('Experience', formData.experience);
        formDataObj.append('Image', formData.image);
        formDataObj.append('Resume', formData.resume);
        formDataObj.append('CurrentWorking', formData.currentWorking);
        formDataObj.append('ConsultationFee', formData.consultationFee);
        formDataObj.append('MedicalDegree', formData.medicalDegree);
        formDataObj.append('Authority', formData.authority);
        formDataObj.append('LicenseNo', formData.licenseNo);
        formDataObj.append('InstituteCountry', formData.institutecountry);
        formDataObj.append('InstituteName', formData.institutename);

        try {
            const response = await fetch(`${BASE_URL}Specialist_RegisterDoctor`, {
                method: 'POST',
                body: formDataObj,
            });
            const data = await response.json();

            if (!response.ok) {
                const errorResponse = await response.json();
                throw new Error(errorResponse.Message || data.message || 'Please Contact With IT / Admin');
            }

            // const data = await response.json();
            console.log('Registration successful:', data);

            Swal.fire({
                title: 'Success!',
                text: 'Registration successful!',
                icon: 'success',
                confirmButtonText: 'OK'
            });

            setFormData({
                fullName: '',
                email: '',
                password: '',
                cnic: '',
                contactNo: '',
                dob: '',
                city: '',
                country: '',
                currentAddress: '',
                permanentAddress: '',
                licenseNo: '',
                medicalInstitute: '',
                experience: '',
                currentWorking: '',
                consultationFee: '',
                doctorDutyTime: '',
                charges: '',
                terms: false,
                specialization: '',
                image: null,
                authority: '',
                institutecountry: '',
                resume: null,
                medicalDegree: null,
                gender: '',
                institutename: '',
                SpecialtyId: '',
            });
        } catch (error) {
            console.error('Registration failed:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message || 'An unexpected error occurred.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    return (
        <MDBContainer fluid className='h-custom'>
            <MDBRow className='d-flex justify-content-center align-items-center h-100'>
                <MDBCol col='12' className='m-5'>
                    <MDBCard className='card-registration card-registration-2' style={{ borderRadius: '15px' }}>
                        <MDBCardBody className='p-0'>
                            <MDBRow>
                                <MDBCol md='6' className='p-5 bg-white'>
                                    <h3 className="fw-normal mb-5" style={{ color: '#4835d4' }}>General Information</h3>

                                    <MDBRow>
                                        <MDBCol md='6'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Full Name</>}
                                                size='lg'
                                                name='fullName'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='6'>
                                            <div className="form-group">
                                                <div className="form-floating">
                                                    <input
                                                        type="file"
                                                        className="form-control form-control-lg"
                                                        id="image"
                                                        name="image"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label htmlFor="image">Upload Image</label>
                                                </div>
                                            </div>
                                            {/* <MDBInput
                                                wrapperClass='mb-4'
                                                label='Upload Image'
                                                size='lg'
                                                name='image'
                                                type='file'
                                                onChange={handleFileChange}
                                            /> */}
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md='6'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span> Doctor@email.com</>}

                                                size='lg'
                                                name='email'
                                                type='email'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='6'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span> Password</>}

                                                size='lg'
                                                name='password'
                                                type='password'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                    </MDBRow>

                                    <MDBRow>
                                        <MDBCol md='4'>
                                            {/* <MDBInput
                                                wrapperClass='mb-4'
                                                label='CNIC'
                                                size='lg'
                                                maxlength="13"
                                                pattern="[0]{1}[0-9]{10}"name='cnic'
                                                type='number'
                                                onChange={handleInputChange}
                                            /> */}
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span> CNIC</>}
                                                size='lg'
                                                name='cnic'
                                                type='text'
                                                maxlength="13"
                                                pattern="[0]{1}[0-9]{10}"
                                                value={formData.cnic}
                                                onChange={handleInputChange}
                                                required
                                            />

                                        </MDBCol>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span> Contact Number</>}
                                                size='lg'
                                                name='contactNo'

                                                type="text"
                                                maxlength="11"
                                                pattern="[0]{1}[0-9]{10}"
                                                value={formData.contactNo}

                                                onChange={handleInputChange}
                                                required
                                            />
                                            {/* <MDBInput
                                                wrapperClass='mb-4'
                                                class="form-control"

                                                label='Mobile Number'
                                                size='lg'
                                                maxlength="11"
                                                pattern="[0]{1}[0-9]{10}"
                                                name='contactNo' // Updated name to contactNo
                                                type='number'
                                                onChange={handleInputChange}
                                            /> */}
                                        </MDBCol>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label='Date of Birth'
                                                size='lg'
                                                name='dob'
                                                type='date'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                    </MDBRow>

                                    <MDBRow>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>City</>}

                                                size='lg'
                                                name='city'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Country</>}
                                                size='lg'
                                                name='country'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='4'>
                                            <div className='d-md-flex justify-content-start align-items-center mb-4'>
                                                <h6 className="fw-bold mb-0 me-4">Gender: </h6>
                                                <MDBRadio name='gender' id='genderFemale' value='Female' label='Female' inline onChange={handleInputChange} checked />
                                                <MDBRadio name='gender' id='genderMale' value='Male' label='Male' inline onChange={handleInputChange} />
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md='12'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Current Address</>}

                                                size='lg'
                                                name='currentAddress'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>

                                <MDBCol md='6' className='bg-indigo p-5'>
                                    <h3 className="fw-normal mb-5 text-white">Professional Information</h3>

                                    <MDBRow>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>License Number</>}

                                                size='lg'
                                                name='licenseNo'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Institute Name</>}

                                                size='lg'
                                                name='institutename'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='4'>
                                            <div className="form-group">
                                                <div className="form-floating">
                                                    <input
                                                        type="file"
                                                        className="form-control form-control-lg"
                                                        id="medicalDegree"
                                                        name="medicalDegree"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label htmlFor="medicalDegree">Upload Medical Degree</label>
                                                </div>
                                            </div>
                                            {/* <MDBInput
                                                wrapperClass='mb-4'
                                                label='Upload Medical Degree'
                                                size='lg'
                                                name='medicalDegree'
                                                type='file'
                                                onChange={handleFileChange}
                                            /> */}
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md='6'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Country Name who issue License</>}
                                                size='lg'
                                                name='institutecountry'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='6'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Charges per Consultation (PKR)</>}

                                                size='lg'
                                                name='consultationFee'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>

                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Current Working</>}
                                                size='lg'
                                                name='currentWorking'
                                                type='text'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='4'>
                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Experience (Years)</>}
                                                size='lg'
                                                name='experience'
                                                type='number'
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                        <MDBCol md='4'>

                                            <MDBInput
                                                wrapperClass='mb-4'
                                                label={<><span className="required">*</span>Doctor Duty Time</>}
                                                size='lg'
                                                name='doctorDutyTime'
                                                type='text'
                                                onChange={handleInputChange}
                                            />

                                            <input
                                                wrapperClass='mb-4'
                                                name='authority'
                                                type='text'
                                                onChange={handleInputChange}
                                                style={{ display: "none" }}
                                                value="-"
                                            />
                                        </MDBCol>

                                    </MDBRow>

                                    <MDBRow>
                                        <MDBCol md='4'>
                                            <MDBDropdown group>
                                                <MDBDropdownToggle color="secondary" className="w-100">
                                                    {formData.specialization || "Search Specialization"} {/* Display selected specialization or default text */}
                                                </MDBDropdownToggle>
                                                <MDBDropdownMenu style={{ maxHeight: '300px', overflowY: 'auto', zIndex: 1050 }}>
                                                    <MDBInput
                                                        type="text"
                                                        placeholder="Search..."
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                        className="p-2 required"
                                                    />
                                                    {filteredSpecialists.length === 0 ? (
                                                        <MDBDropdownItem disabled>No results found</MDBDropdownItem>
                                                    ) : (
                                                        filteredSpecialists.slice(0, 10).map((specialist) => (
                                                            <MDBDropdownItem
                                                                onClick={() => handleSpecialtyChange(specialist)}
                                                                key={specialist.id}
                                                            >
                                                                {specialist.specialization_Name}
                                                            </MDBDropdownItem>
                                                        ))
                                                    )}
                                                </MDBDropdownMenu>
                                            </MDBDropdown>
                                        </MDBCol>
                                        <MDBCol md='4'>

                                            <div className="form-group">
                                                <div className="form-floating">
                                                    <input
                                                        type="file"
                                                        className="form-control form-control-lg required"
                                                        id="resume"
                                                        name="resume"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label htmlFor="resume">Upload Resume</label>
                                                </div>
                                            </div>
                                            {/* <MDBInput
                                                wrapperClass='mb-4'
                                                label='Upload Resume'
                                                size='lg'
                                                name='resume'
                                                type='file'
                                                onChange={handleFileChange}
                                            /> */}


                                        </MDBCol>

                                        <MDBCol md='4'>

                                        </MDBCol>

                                    </MDBRow>

                                    <MDBRow>
                                        <MDBCol md='6'>
                                            <MDBCheckbox
                                                name='terms'
                                                id='terms'
                                                label='I agree to the Terms and Conditions'
                                                checked={formData.terms}
                                                onChange={handleInputChange}
                                            />
                                        </MDBCol>
                                    </MDBRow>

                                    <MDBBtn
                                        className='mb-4 w-100'
                                        size='lg'
                                        onClick={handleSubmit}
                                        disabled={!formData.terms}
                                    >
                                        Register
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}

export default Register;

